import { render } from "./TermsandConditions.vue?vue&type=template&id=688b8bef"
const script = {}
script.render = render

export default script